import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { isEqual } from 'lodash-es';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { DeviceRoles } from '@vi-iot/client';
import { ActiveErrorsStore, GatewayStore, RemoteDeviceDetails } from '@store';
import { InstallationService } from '../../../../../services/installation.service';
import { CommissioningService } from '../../../commissioning/commissioning.service';

@Component({
  selector: 'app-all-added-devices-modal',
  templateUrl: './all-added-devices-modal.component.html',
  styleUrls: ['./all-added-devices-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AllAddedDevicesModalComponent implements OnInit, OnDestroy {
  devices: RemoteDeviceDetails[] = [];

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  DeviceRoles = DeviceRoles;
  constructor(
    public dialogRef: MatDialogRef<AllAddedDevicesModalComponent>,
    public gatewayStore: GatewayStore,
    public installationService: InstallationService,
    public activeErrorsStore: ActiveErrorsStore,
    private commissioningService: CommissioningService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.gatewayStore.allGatewayDevicesDetails$
      .pipe(
        takeUntil(this.ngUnsubscribe$),
        filter((devices: RemoteDeviceDetails[]) => {
          const areDifferent = !isEqual(devices, this.devices);
          const devicesEmpty = !this.devices.length;

          return devicesEmpty || areDifferent;
        })
      )
      .subscribe((devices: RemoteDeviceDetails[]) => {
        const filterDevices = [this.DeviceRoles.RemoteControllerVitotrol100E];
        this.devices = devices.filter(
          (dev) => !filterDevices.some((role) => dev?.device?.roles.includes(role))
        );

        this.cdr.detectChanges();

        if (!this.devices.length) {
          this.dialogRef.close();
        }
      });
  }

  onAddDevice(): void {
    this.commissioningService.openAddDeviceDialog();
    this.dialogRef.close();
  }

  // TODO commented by VIG-2626, VIG-2729
  //
  // getClassBasedOnWifiStrength(value: number): string {
  //   if (isNaN(value) || value === null) {
  //     return '';
  //   }

  //   return WIFI_STRENGTH_CLASS[this.wifiStrengthPipe.transform(value)];
  // }

  onClose(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
